import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaShareAlt,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SocialMediaContentCreationInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Social Media Content Creation in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Online Presence</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Social Media Content Creation</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our social media content creation services in
            **Al Barsha** deliver engaging, high-impact videos, graphics, and
            posts that amplify your brand’s reach. From Instagram reels to
            LinkedIn campaigns, we craft content that drives engagement and
            conversions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-e515679aff46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media video production setup
          "https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Content creator filming
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media creative setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Social Media Content Creation in Al Barsha"
        description="We create scroll-stopping content tailored to your brand and audience."
        cards={[
          {
            icon: <FaShareAlt color="#ff5464" size={40} />,
            title: "Platform-Specific",
            description:
              "Content optimized for Instagram, LinkedIn, TikTok, and more.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "High Engagement",
            description: "Visually stunning posts that spark interaction.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Delivery",
            description: "Fast turnaround to keep your channels active.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Content designed for seamless mobile viewing.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Experts",
            description: "Al Barsha’s go-to for social media content.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Creation",
            description: "Videos, graphics, and captions, all in one.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Social Media Content Creation Process"
        description={
          <Description>
            We deliver engaging social media content through a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Strategy: Define your brand voice and campaign goals.</li>
              <li>
                Content Planning: Create a content calendar for consistency.
              </li>
              <li>
                Creation: Produce videos, graphics, and captions tailored to
                platforms.
              </li>
              <li>
                Optimization: Ensure content is engaging and platform-specific.
              </li>
              <li>Review: Incorporate your feedback for perfection.</li>
              <li>
                Delivery: Provide ready-to-post content for your channels.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile-first video editing
          "https://images.unsplash.com/photo-1551817958-d9d86fb29431?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional social media setup
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Creative team meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Social Media Wins in Al Barsha"
        description="Our content has transformed social media presence for Al Barsha brands."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Reach",
            description: "Boosted engagement by 10x with a TikTok campaign.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Growth",
            description: "Grew Instagram followers for a local business.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction from social media clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Go Viral?</Subheading>}
        heading="Social Media Content Creation in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional social media content
            creation in Al Barsha. Create engaging, high-impact content that
            grows your brand and drives results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Smartphone with social media apps
          "https://images.unsplash.com/photo-1572048572929-782ede5ee44b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape for social content
          "https://images.unsplash.com/photo-1533422902779-aff35862e462?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Social media content creation
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
